export const entries = {
  UNKNOWN: 1,
  USER_CREATED: 2,
  USER_UPDATED: 3,
  USER_LOGIN: 4,
  USER_LOGOUT: 5,
  USER_DELETED: 6,
  PROJECT_CREATED: 7,
  LICENSE_CREATED: 8,
  GRANT_ACCESS: 9,
  SYNC_STARTED: 10,
  PARTICIPANT_CREATED: 11,
  SCOPE_CREATED: 12,
  LICENSE_SCOPE_ACCESS: 13,
  USER_INVITED: 14,
  PROJECT_OWNER_ADDED: 15,
  LICENSE_DELETED: 16,
  LICENSE_UPDATED: 17,
  REVOKE_OWNER_ACCESS: 18,
  SYNC_SUCCEEDED: 19,
  SYNC_FAILED: 20,
  PROJECT_ARCHIVED: 21,
  PROJECT_UNARCHIVED: 22,
} as const

export type Entries = typeof entries
export type EntryTypeName = keyof Entries
export type EntryTypeId = Entries[EntryTypeName]
